<script>
  import FormLabel from "#lib/FormLabel.svelte";
  import TextInput from "#lib/TextInput.svelte";
  import t from "#lib/i18n.svelte.js";

  let {
    /** @type {string} */
    type, 
    /** @type {string} used for translation string and input name */
    label, 
    /** @type {string} Optional value of the field */
    value = $bindable(), 
    /** @type {string} string for placeholder */
    placeholder,
    /** @type {boolean} */
    required,
    /** @type {boolean} */
    disabled,
    /** @type {boolean} */
    readonly,
    /** @type {'column' | 'row'} */
    orientation = 'row',
    variant,
    class: css_class,
    autocomplete,
    error,
    ...rest
  } = $props();
</script>

<div class='{orientation === "column" ? "flex-column gap-y g-1" : "form-row"} {css_class}'>
  {#if label}
    <FormLabel for={label}>{t(label)}</FormLabel>
  {/if}
  <TextInput 
    id={label} 
    bind:value
    {variant}
    type={type} 
    name={label} 
    {placeholder}
    {disabled}
    {readonly}
    {autocomplete}
    {error}
    {...(required) ? {
      required: true
    } : {}}
    inputmode={type === 'email' ? 'email' : type === 'password' ? 'text' : type === 'number' ? 'numeric' : 'text'}
    {...rest}
  />
</div>